import styled from '@emotion/styled';
import { Colors, media } from '@utex/ui-kit';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 1.5rem;
  margin-bottom: 2rem;
  background: ${Colors.ut.errorDim};
  color: ${Colors.text.error};

  @media ${media.phonablet} {
    padding-left: 1.8rem;
    padding-right: 4rem;
  }
`;
